import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaProgressoCurso = (): TabelaColuna => ({
  Chave: 'progressoCurso',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 100 }}>Progresso Curso</div>
})
